import {Employee} from '../../../core/entities/employee'

const filterEmployees = ({
    ids,
    map,
    filterBy,
}: {
    ids: number[]
    map: Record<number, Employee>
    filterBy: string
}) => {
    return [...ids].filter((id) => {
        const {firstName, lastName, phone, email, role} = map[id]
        const mergedEmployeeDataString = `${firstName.toLocaleLowerCase()} ${lastName.toLocaleLowerCase()} ${phone} ${email.toLocaleLowerCase()} ${role.toLocaleLowerCase()}`
        return mergedEmployeeDataString.includes(filterBy.toLocaleLowerCase())
    })
}

export default filterEmployees
